import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link, useSearchParams} from "react-router-dom";
import JSZip from "jszip";
import { saveAs } from "file-saver";

export const ProductImages = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const assetId = searchParams.get('assetId');

  const [visibleCount, setVisibleCount] = useState(3);

  const [categoryList, setCategoryList] = useState<any[]>([]);
  function getAssetCategoryList() {
    axios({
      method: 'get',
      url: 'https://en.finevu.com/api/controller/admin/brand-assets/asset-categories/getAssetCategoryList.php?sortColumn=categoryName&sortOrder=desc'
    }).then(function (response) {
      const sortedList: any = [...response.data.list].sort((a, b) => {
        return a.sortOrder - b.sortOrder;
      });
      setCategoryList(sortedList);
    });
  }
  useEffect(() => {
    getAssetCategoryList();
  }, []);

  const [subCategoryList, setSubCategoryList] = useState<any>([]);
  function getBrandAssetList() {
    axios({
      method: 'get',
      url: `https://en.finevu.com/api/controller/admin/brand-assets/getBrandAssetList.php?categoryId=${tab}&keyword&sortColumn=ca&sortOrder=desc`
    }).then(function (response) {
      const list = response?.data?.list || [];
      setSubCategoryList(list);

      const activeList = list.filter((item: any) => item.activeStatus === 'Y');

      if (!searchParams.get('assetId') && activeList.length > 0) {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('assetId', activeList[0].ID);
        setSearchParams(newParams, { replace: true });
      }
    });
  }

  useEffect(() => {
    getBrandAssetList();
  }, [tab]);


  const [fileList, setFileList] = useState<any>([]);
  function getAssetFileList() {
    setVisibleCount(3);
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/asset-files/getAssetFileList.php", {
      assetId: assetId,
      categoryId: tab,
    }).then(function (response) {
      if (response?.data?.result) {
        setFileList(response?.data?.list);
      } else {
        alert(response?.data?.msg);
      }
    });
  }
  useEffect(() => {
    getAssetFileList();
  }, [assetId, tab]);

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 3);
  };




  const handleAllDownloadAsZip = async () => {
    if (!fileList || fileList.length === 0) {
      alert("다운로드할 이미지가 없습니다.");
      return;
    }

    const currentSubCategory = subCategoryList?.find(
      (item: any) => searchParams.get("assetId") === String(item.ID)
    );

    const zipFileName = currentSubCategory
      ? `${currentSubCategory.title}_Image_Pack`
      : "Brand_Asset_Pack";

    const zip = new JSZip();

    try {
      const downloadPromises = fileList.map(async (file: any, index: number) => {
        const fileUrl = file?.filePath;

        if (!fileUrl) return false;

        try {
          const response = await fetch(fileUrl);

          if (!response.ok) {
            throw new Error(`HTTP 에러! 상태코드: ${response.status}`);
          }

          const blob = await response.blob();

          // URL 에서 원본 파일명 추출
          const urlParts = fileUrl.split("/");
          const originalFileName = urlParts[urlParts.length - 1].split("?")[0];

          // 파일명 중복 방지
          const finalFileName = `${index + 1}_${originalFileName}`;

          zip.file(finalFileName, blob);

          return true;
        } catch (fileError) {
          console.error(`파일 다운로드 실패 주소: (${fileUrl})`, fileError);
          return false;
        }
      });

      const results = await Promise.all(downloadPromises);

      const successCount = results.filter(Boolean).length;

      if (successCount === 0) {
        alert("모든 이미지 다운로드에 실패했습니다.");
        return;
      }

      const content = await zip.generateAsync({ type: "blob" });

      saveAs(content, `${zipFileName}.zip`);

    } catch (error) {
      console.error("ZIP 생성 중 오류 발생:", error);
      alert("압축 패키지 다운로드 중 오류가 발생했습니다.");
    }
  };

  return (
    <>
      <div className="contentBox">
        <h2>
          Create content with our official assets
        </h2>
        <p>Download ready-to-use product visuals and brand assets to streamline your content creation.</p>
        <div className="brand-assets-categoryTab">
          {categoryList?.map((cat: any) => (
            cat.activeStatus === 'Y' && (
              <Link to={`?tab=${cat.ID}`} key={cat.ID} className={Number(tab) === cat.ID ? 'active' : ''}>
                {cat.categoryName}
              </Link>
            )
          ))}
        </div>
        {tab === '1' && (
          <>
            <div className="brand-assets-sub-categoryTab">
              {subCategoryList
                ?.filter((item: any) => item?.activeStatus === 'Y') // activeStatus가 'Y'인 항목만 필터링
                .map((item: any, index: number) => {
                  const newParams = new URLSearchParams(searchParams);
                  newParams.set('assetId', item.ID);
                  return (
                    <Link
                      to={{ search: `?${newParams.toString()}` }}
                      key={index}
                      className={searchParams.get('assetId') === String(item.ID) ? 'active' : ''}
                    >
                      {item?.title}
                    </Link>
                  );
                })}
            </div>
            <div className="brand-assets-content-top">
              <div>
                <h3>
                  {subCategoryList?.map((item: any, index: number) => {
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set('assetId', item.ID);
                    return (
                      <>
                        {searchParams.get('assetId') === String(item.ID) && item?.title}
                      </>
                    );
                  })}
                </h3>
                <p>Clean product shots optimized for thumbnails and overlays.</p>
              </div>
              <button onClick={handleAllDownloadAsZip}><img src="/assets/images/brand-assets/download-icon.svg" alt=""/> Download All Image Pack</button>
            </div>
            <ul className="brand-assets-image-list">
              {fileList.length > 0 && fileList.slice(0, visibleCount).map((item: any, index: number) => (
                <li key={index}>
                  <div>
                    <img src={item?.filePath} alt={item?.assetTitle || "visual"}/>
                    <a href={item?.filePath} download target="_blank"></a>
                  </div>
                  <span>{item.assetTitle}</span>
                </li>
              ))}
            </ul>
            {fileList.length > visibleCount && (
              <div className="brand-more-button">
                <button onClick={handleLoadMore}>Load more</button>
              </div>
            )}
          </>
        )}

        {tab === '2' && (
          <>
            <div className="brand-assets-sub-categoryTab">
              {subCategoryList
                ?.filter((item: any) => item?.activeStatus === 'Y')
                .map((item: any, index: number) => {
                  const newParams = new URLSearchParams(searchParams);
                  newParams.set('assetId', item.ID);
                  return (
                    <Link
                      to={{ search: `?${newParams.toString()}` }}
                      key={index}
                      className={searchParams.get('assetId') === String(item.ID) ? 'active' : ''}
                    >
                      {item?.title}
                    </Link>
                  );
                })}
            </div>
            <div className="brand-assets-content-top">
              <div>
                <h3>
                  {subCategoryList?.map((item: any, index: number) => {
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set('assetId', item.ID);
                    return (
                      <>
                        {searchParams.get('assetId') === String(item.ID) && item?.title}
                      </>
                    );
                  })}
                </h3>
                <p>Short, editable video clips to support your storytelling.</p>
              </div>
            </div>
            <ul className="brand-assets-image-list">
              {fileList.length > 0 && fileList.slice(0, visibleCount).map((item: any, index: number) => (
                <li key={index}>
                  <div>
                    <img src={`https://en.finevu.com/${item?.thumbPath}`} alt={item.fileDisplayName || "video thumbnail"}/>
                    <a href={item?.videoLink} target="_blank" rel="noopener noreferrer"></a>
                  </div>
                  <span>{item.fileDisplayName}</span>
                </li>
              ))}
            </ul>
            {fileList.length > visibleCount && (
              <div className="brand-more-button">
                <button onClick={handleLoadMore}>Load more</button>
              </div>
            )}
          </>
        )}

        {tab === '3' && (
          <div className="brand-identity">
            <p>FineDigital's wordmark, the symbolic image representing its visual communication, is the most important and central element in
              all media expressions. Therefore, when utilizing the wordmark, it is essential to adhere to all applicable regulations and principles
              to prevent distortion, alteration, or misuse of the image.</p>
            <ul className="bi">
              {fileList.length > 0 && fileList.slice(0, visibleCount).map((item: any, index: number) => (
                <li key={index}>
                  <img src={item?.filePath} alt={item?.assetTitle || "visual"}/>
                </li>
              ))}
            </ul>
            <div className="bi-download">
              <button onClick={handleAllDownloadAsZip}><img src="/assets/images/brand-assets/download-icon.svg" alt=""/> All Download</button>
            </div>
          </div>
        )}

        <div className="brand-assets-send-mail">
        <a href="mailto:support@finedigital.com">
            <h3>Get In Touch</h3>
            <p className="send-image"><img src="/assets/images/brand-assets/send-email.png" alt=""/></p>
            <p className="send-text-01">Email Inquiry</p>
            <p className="send-text-02">support@finedigital.com</p>
          </a>
        </div>
      </div>
    </>
  )
}
